import { ScheduleBook } from './Book';
import { ScheduleConfirmation } from './Confirmation';
import { ScheduleSearch } from './Search';

export const Schedule = {
  Book: ScheduleBook,
  Confirmation: ScheduleConfirmation,
  Search: ScheduleSearch
};
